import { getValue } from '../utils/ConfigProvider'

const config = {
  basePath: '',
  home: 'https://www.argos.co.uk',
  domain: 'www.argos.co.uk',
  xhrPath: '/finder-api', // Path for XHR to be served from
  xhrTimeout: 5000,
  httpStatusCodes: {
    success: 200,
    serverError: 500,
    serviceUnavailable: 503,
    notFound: 404,
    permanentRedirect: 301,
    temporaryRedirect: 302
  },
  getProductPath: (partNumber) => {
    return `product/${partNumber}`
  },
  globalFilterIds: ['fasttrack', 'price', 'customer rating'],
  dfp: {
    channelId: 42685526,
    enabled: true
  }
}

const sortByNewValues = [{
  'key': 'newness_desc',
  'value': {
    'type': 'newness',
    'order': 'desc'
  },
  'label': 'New Arrivals',
  'path': 'sort:new-arrivals'
}]

const sortByValues = [{
  'key': 'price_asc',
  'value': {
    'type': 'price',
    'order': 'asc'
  },
  'label': 'Price: Low - High',
  'path': 'sort:price'
}, {
  'key': 'price_desc',
  'value': {
    'type': 'price',
    'order': 'desc'
  },
  'label': 'Price: High - Low',
  'path': 'sort:price:desc'
}, {
  'key': 'customer rating_desc',
  'value': {
    'type': 'customer rating',
    'order': 'desc'
  },
  'label': 'Customer Rating',
  'path': 'sort:customer-rating'
}, ...(getValue('features.productList.enableSortbyNew') ? sortByNewValues : [])]

config.searchSortByValues = [{
  'key': 'relevance_desc',
  'value': {
    'type': 'relevance',
    'order': 'desc'
  },
  'label': 'Relevance',
  'path': ''
}, ...sortByValues]

config.browseSortByValues = [{
  'key': 'relevance_desc',
  'value': {
    'type': '',
    'order': ''
  },
  'label': 'Relevance',
  'path': ''
}, ...sortByValues]

const categoryTypes = {
  PLP: 'PLP',
  CLP: 'CLP',
  PLPPLUS: 'PLPPLUS',
  SUBHEADING: 'SUBHEADING',
  TOPLEVELCATEGORY: 'TOPLEVELCATEGORY',
  MASTERCATEGORY: 'MASTERCATEGORY'
}

const contentAreaTypes = {
  BackgroundImageGrid: 'GL018',
  GridLayoutThree: 'GL003',
  NavigationComponent: 'M012',
  BackgroundHeading: 'M0092',
  ContentInList: 'M053'
}

const contentAreaIds = {
  AreaB: 'B',
  AreaD: 'D',
  SeoArea: 'SEO',
  Dfp: {
    top: 'DFPTOP',
    bottom: 'DFPBOTTOM'
  },
  ContentInListArea: 'G'
}

const seoMetaPlaceholders = {
  category: '{{cat}}',
  refinement: '{{ref}}',
  brand: '{{brand}}',
  categoryFallback: '{{cat}} | {{brand}}',
  categoryRefinedFallback: '{{ref}} {{cat}} | {{brand}}'
}

const searchTypes = {
  brandsNIC: 'nic',
  didYouMean: 'dym',
  spellChecked: 'sc',
  NRS: 'nrs'
}

config.adSense = {
  stopWords: ['our', 'best', 'deals', 'on', 'for', 'fantastic', 'offers', 'at', 'argos', 'under', 'shop', 'savings', 'great', 'all', 'shop', 'day', 'amazing', 'seven', 'stock', 'limited', 'selected', 'home and garden', 'Technology', 'pounds', '2 for', 'sports and leisure', 'Jewellery and watches', 'Health and beauty', 'see', 'wow', 'under', 'beginner'],
  browse: {
    enabled: true,
    elementId: 'adsense-footer',
    channelId: {
      desktop: {
        SLP: 6768544131,
        noResults: 7386168737
      },
      mobile: {
        SLP: 4222615939,
        noResults: 8862901932
      }
    },
    advertCount: {
      mobile: {
        noResults: 3,
        hasResults: 2
      },
      desktop: 3
    },
    pubId: 'pub-2476674212740568'
  },
  search: {
    enabled: true,
    elementId: 'adsense-footer',
    channelId: {
      desktop: {
        SLP: 8745955930,
        noResults: 7386168737
      },
      mobile: {
        SLP: 7269222731,
        noResults: 8862901932
      }
    },
    advertCount: {
      mobile: {
        noResults: 3,
        hasResults: 2
      },
      desktop: 3
    },
    pubId: 'pub-2476674212740568'
  }
}

const availabilityExclusions = [
  // PS5
  '/browse/technology/video-games-and-consoles/ps5/ps5-consoles/c:812421',
  '/browse/technology/video-games-and-consoles/ps5/c:812419',
  '/search/ps5-console',
  '/search/ps5-digital',
  '/search/ps5-consol',
  '/search/ps5-consoles',
  '/search/playstation-5-console',
  '/search/playstation-5-sony-console',
  '/search/sony-playstation-5-console',
  '/search/ps5',
  '/search/ps-5',
  '/search/ps5-bundle',
  '/search/ps5-console-bundle',
  '/search/sony-playstation-5',
  '/search/sony-ps5',
  '/search/playstation-5',
  '/search/playstation',
  // Rings
  '/browse/jewellery-and-watches/womens-jewellery/womens-rings/c:29317',
  '/browse/jewellery-and-watches/mens-jewellery/mens-rings/c:29330',
  '/list/shop-for-engagement-rings',
  '/list/shop-for-engagement-and-bridal',
  '/list/shop-all-rings-at-argos',
  '/list/shop-all-jewellery-at-argos',
  '/list/shop-for-mens-wedding-rings',
  '/search/rings',
  '/search/engagement-ring/',
  '/search/ring',
  '/search/wedding-ring',
  '/search/mens-rings'
]

export {
  categoryTypes,
  contentAreaTypes,
  contentAreaIds,
  seoMetaPlaceholders,
  searchTypes,
  availabilityExclusions
}
export default config
